import { Tooltip } from 'floating-vue'

import { isEmpty } from 'lodash'

import TooltipIcon from '../../icons/tooltip-icon/TooltipIcon.vue'

export default {
  name: 'TooltipError',
  components: {
    Tooltip,
    TooltipIcon
  },
  props: {
    errors: { type: Array, required: true },
    placement: { type: String, default: 'bottom-end' }
  },
  setup(props) {
    return {
      props,
      isEmpty
    }
  }
}
